// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__18Z1V","header":"MergedInvoice_header__3VI8i"};